import rawConfig from '../data/config.json';
import type { SimState } from '../sim/types';
import { saveSlot } from './storage';
import type { Clock, SaveResult, StorageLike } from './types';

export class AutoSaveManager {
  private lastSavedRealMs: number = 0;
  private lastSavedGameDay: number = 1;
  private isEnabled: boolean = true;
  private minIntervalMs: number;

  constructor(
    private storage: StorageLike,
    private clock: Clock = () => new Date().toISOString(),
    minIntervalMs: number = rawConfig.autosave.minIntervalMs
  ) {
    this.minIntervalMs = minIntervalMs;
  }

  public setEnabled(enabled: boolean): void {
    this.isEnabled = enabled;
  }

  public getIsEnabled(): boolean {
    return this.isEnabled;
  }

  /**
   * Cek pemicu auto-save di akhir frame:
   * Dipanggil saat nomor hari game bertambah atau dipicu event window (visibilitychange/pagehide).
   */
  public triggerAutoSave(state: SimState, currentDay: number, force: boolean = false): SaveResult | null {
    if (!this.isEnabled) {
      return null;
    }

    const nowRealMs = Date.now();
    const isNewDay = currentDay > this.lastSavedGameDay;
    const isThrottled = nowRealMs - this.lastSavedRealMs < this.minIntervalMs;

    if (!force && (!isNewDay || isThrottled)) {
      return null;
    }

    const result = saveSlot(this.storage, 'autosave', state, this.clock);
    if (result.ok) {
      this.lastSavedRealMs = nowRealMs;
      this.lastSavedGameDay = currentDay;
    }
    return result;
  }
}

